module.exports = __webpack_public_path__ + "static/media/handshake.dfdaa47f.svg";